var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('UserNavigation'),_c('h1',[_vm._v("O nama")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }